import { MessageableFactory, SignalableFactory } from '@locumsnest/core/src';

export const messageableFactory =
  MessageableFactory.forFeature<'PassportFilterUI'>('PassportFilterUI');
export const signalableFactory =
  SignalableFactory.forFeature<'PassportFilterUI'>('PassportFilterUI');
